import { ItemLoader } from "@/loaders";

export default {
  item: new ItemLoader("/help-references/", {
    lookupField: "identifier",
    setter: "helpReference/addHelpReference",
  }),
};
